var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-container-base',{attrs:{"title":'Creación de usuario'}},[_c('app-form-base',{attrs:{"forms":_vm.form,"waiting":_vm.isLoading,"routing":'',"reset":_vm.reset},on:{"onGetData":_vm.onGetData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }